export const baseUrl = '/api/afd/captcha/v1/';
export const baseUrl1 = '/api/v2/';
export const baseUrl2 = '/api/v3/';
export const baseUrl3 = '/api/v1/';
